import React from "react";
import { MenuItemSingleStyled } from "./menuItemSingle.styles";
import icon from "../../assets/img/icon_all_auction.png";
import '../../app/App.css'
const MenuItemSingle = ({ title, ...others }) => {
  return (
    <MenuItemSingleStyled {...others}>
      <button className="font-weight-bold">
        <span className="icon position-relative">
          <img src={icon} width="100%" alt="" />
        </span>
        <span>{title}</span>
      </button>
    </MenuItemSingleStyled>
  );
};

export default MenuItemSingle;
